export { default } from './globe-2'
